import React, { useEffect, useState } from "react";

import { useQuery } from "@apollo/react-hooks";
import { useReleases } from "../PhotoUpload/Releases/hooks/useReleases";

import { GET_LIST_RELEASES_IN_BATCH } from "./queries";

import UploadMoreToolbarButton from "./UploadMoreToolbarButton";
import ManageReleasesModal from "../PhotoUpload/Releases/ManageReleasesModal";

import {
    determineReleaseButtonTitle,
    sortReleasesAlphabetically
} from "frontend/components/creator-tools/PhotoUploadPage/helpers";

import { OtherControlsContainer, ToolbarButton } from "./styles";

const PhotoUploadToolbarOtherControls = () => {
    const [manageReleaseModalIsOpen, setManageReleaseModalIsOpen] = useState(
        false
    );

    const {
        setReleases,
        hasReleases,
        setReleaseUploadErrorMessage
    } = useReleases();

    const { data } = useQuery(GET_LIST_RELEASES_IN_BATCH, {
        variables: {
            limit: 100,
            status: "UPLOAD_COMPLETE"
        }
    });

    const releases =
        (data &&
            data.listReleasesInModerationPhotoBatch &&
            data.listReleasesInModerationPhotoBatch.items) ||
        [];

    const numOfReleases = hasReleases.length;

    useEffect(() => {
        if (releases.length > 0) {
            const sorted = sortReleasesAlphabetically(releases);
            setReleases(sorted);
        }
    }, [releases, setReleases]);

    const closeModal = () => {
        setManageReleaseModalIsOpen(false);
        setReleaseUploadErrorMessage("");
    };

    const buttonTitleForToolbar = determineReleaseButtonTitle(numOfReleases);

    return (
        <OtherControlsContainer>
            <ToolbarButton onClick={() => setManageReleaseModalIsOpen(true)}>
                {buttonTitleForToolbar}
            </ToolbarButton>
            <UploadMoreToolbarButton />

            <ManageReleasesModal
                numReleasesUploaded={numOfReleases}
                onClose={closeModal}
                isModalOpen={manageReleaseModalIsOpen}
            />
        </OtherControlsContainer>
    );
};

export default PhotoUploadToolbarOtherControls;
